import { get } from '../../shared/api';
import { DefaultResponseDTO } from '../../shared/constants';

export const getTermsRequest = (): Promise<DefaultResponseDTO<string>> => get<DefaultResponseDTO<string>>('/terms');
